<template>
    <div>
        <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
            Margin
        </div>
        <div class="flex flex-wrap items-center">
            <div class="w-1/2">
                <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="flex items-center">
                        <div class="w-auto pr-1">
                            <app-icon icon="arrow-up" />
                        </div>
                        <div class="flex-grow w-auto">
                            <app-field-slider
                                class="reset"
                                :data="data"
                                v-model="element.settings.boxModel.margin.top"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-1/2">
                <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="flex items-center">
                        <div class="w-auto pr-1">
                            <app-icon icon="arrow-right" />
                        </div>
                        <div class="flex-grow w-auto">
                            <app-field-slider
                                class="reset"
                                :data="data"
                                v-model="element.settings.boxModel.margin.right"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-1/2">
                <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="flex items-center">
                        <div class="w-auto pr-1">
                            <app-icon icon="arrow-down" />
                        </div>
                        <div class="flex-grow w-auto">
                            <app-field-slider
                                class="reset"
                                :data="data"
                                v-model="element.settings.boxModel.margin.bottom"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-1/2">
                <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="flex items-center">
                        <div class="w-auto pr-1">
                            <app-icon icon="arrow-left" />
                        </div>
                        <div class="flex-grow w-auto">
                            <app-field-slider
                                class="reset"
                                :data="data"
                                v-model="element.settings.boxModel.margin.left"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
            Padding
        </div>
        <div class="flex flex-wrap items-center">
            <div class="w-1/2">
                <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="flex items-center">
                        <div class="w-auto pr-1">
                            <app-icon icon="arrow-up" />
                        </div>
                        <div class="flex-grow w-auto">
                            <app-field-slider
                                class="reset"
                                :data="data"
                                v-model="element.settings.boxModel.padding.top"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-1/2">
                <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="flex items-center">
                        <div class="w-auto pr-1">
                            <app-icon icon="arrow-right" />
                        </div>
                        <div class="flex-grow w-auto">
                            <app-field-slider
                                class="reset"
                                :data="data"
                                v-model="element.settings.boxModel.padding.right"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-1/2">
                <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="flex items-center">
                        <div class="w-auto pr-1">
                            <app-icon icon="arrow-down" />
                        </div>
                        <div class="flex-grow w-auto">
                            <app-field-slider
                                class="reset"
                                :data="data"
                                v-model="element.settings.boxModel.padding.bottom"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-1/2">
                <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="flex items-center">
                        <div class="w-auto pr-1">
                            <app-icon icon="arrow-left" />
                        </div>
                        <div class="flex-grow w-auto">
                            <app-field-slider
                                class="reset"
                                :data="data"
                                v-model="element.settings.boxModel.padding.left"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FieldSlider from '@/components/fields/inputs/Slider';

    export default {
        components: {
            'app-field-slider': FieldSlider,
        },
        props: {
            element: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            data:  [
                0, 4, 8, 12, 16, 20, 24, 32, 40, 48, 64, 80, 96, 128
            ],
            fields: {
                margin: {
                    top: {
                        attribute: 'marginTop'
                    },
                    right: {
                        attribute: 'marginRight'
                    },
                    bottom: {
                        attribute: 'marginBottom'
                    },
                    left: {
                        attribute: 'marginLeft'
                    }
                },
                padding: {
                    top: {
                        attribute: 'paddingTop'
                    },
                    right: {
                        attribute: 'paddingRight'
                    },
                    bottom: {
                        attribute: 'paddingBottom'
                    },
                    left: {
                        attribute: 'paddingLeft'
                    }
                },
            }
        }),
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Forms/Partials/BoxModel.vue